import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';
import { playbookContent, filtersById, shareUrl } from './types';
import {
  requestPlaybookContentFailure,
  requestPlaybookContentSuccess,
  requestShareUrlFailure,
  requestShareUrlSuccess,
  requestFiltersByIdSuccess,
  requestFiltersByIdFailure,
} from './actions';

const logger = new Logger('Saga:PlaybookContent');

export function* requestPlaybookContentSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(authApiService.get, routerService.generate('api.content.playbook'));

    yield put(requestPlaybookContentSuccess(action, response.data));
  } catch (error) {
    logger.error('Failed to get playbook content with the following error', error);

    yield put(requestPlaybookContentFailure(action, error));
  }
}

export function* requestFiltersByIdSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.content.playbookfilters', { id: action.filtersId }),
    );

    yield put(requestFiltersByIdSuccess(action, response.data));
  } catch (error) {
    logger.error('Failed to request lesson url with the following error', error);
    yield put(requestFiltersByIdFailure(action, error));
  }
}

export function* requestShareUrlSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.content.playbook_shareable_url'),
      action.payload,
    );

    yield put(requestShareUrlSuccess(action, response.data));
  } catch (error) {
    logger.error('Failed to copy to clipboard', error);
    yield put(requestShareUrlFailure(action, error));
  }
}

export default function* playbookContentSaga() {
  return yield all([
    takeLatest(playbookContent.request, requestPlaybookContentSaga),
    takeLatest(filtersById.request, requestFiltersByIdSaga),
    takeLatest(shareUrl.request, requestShareUrlSaga),
  ]);
}
